<template>
  <tr>
    <td>
      <v-form ref="date_form" v-model="date_valid">
        <v-menu
          v-model="date_menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formattedDate"
              outlined
              dense
              readonly
              v-bind="attrs"
              v-on="on"
              label="Date"
              @click:clear="dataItem.date = null"
              :rules="[$rules.required]"
              append-icon="today"
              @click:append="date_menu = true"
              class="pt-6"
            >
            </v-text-field>
          </template>
          <v-date-picker
            v-model="dataItem.date"
            @input="date_menu = false"
          ></v-date-picker>
        </v-menu>
      </v-form>
    </td>
    <td>
      <v-form ref="value_form" v-model="value_valid">
        <v-text-field
          outlined
          dense
          v-model="dataItem.value"
          :rules="[$rules.required, $rules.double]"
          class="pt-6"
        >
        </v-text-field>
      </v-form>
    </td>
    <td>
      <v-btn icon @click="save" :loading="saving" color="success">
        <v-icon>check_circle</v-icon>
      </v-btn>
    </td>
    <td>
      <v-btn icon @click="cancel" v-if="!saving" color="error">
        <v-icon>cancel</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "EditBusinessMetricItem",
  components: {},
  props: { dataItem: { type: Object } },
  data: () => ({
    date_menu: false,
    saving: false,
    date_valid: false,
    value_valid: false
  }),
  watch: {},
  computed: {
    isAdd() {
      return !this.dataItem.id;
    },
    formattedDate() {
      if (this.dataItem.date) {
        return moment(this.dataItem.date).format("MM/DD/YYYY");
      }
      return "";
    },
    ...mapGetters({})
  },
  methods: {
    save() {
      if (this.$refs.date_form.validate() && this.$refs.value_form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("company/saveBusinessMetricItem", this.dataItem)
          .then(() => {
            this.$emit("save");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
